/* Dynamic Plot code copyright 2011 (c) Craig D. Miller */
/**
 * created by cmiller
 */

import Raphael from 'raphael';
// import {Dyn} from './dynMiscellany';
// import mediator from './mediatorUtil';

export const wrapDyncolorUtil = function(Dyn) {
    let mediator = Dyn.mediator;

    class SVG_Color {
        /**
         * Construct an RGB an SVG-compatible color string, which can later be converted to a
         * HSB_Color or RGB_Color
         * {{colorString: {string]}}}
         * @param str - SVG/Raphael color string
         */
        constructor( str ) {
            this.colorString = str || "#000";
        }
    }
    class RGB_Color extends SVG_Color {
        /**
         * Construct an RGB color,
         * With an SVG-compatible color string plus standard Red, Blue and Green components in the [0-1] range.
         * {{r: *, s: *, b: *, colorString: *}}
         * @param red
         * @param green
         * @param blue
         * @param str - SVG/Raphael color string
         */
        constructor( red, green, blue, str ) {
            super( str );
            this.r = red || 0;
            this.g = green || 0;
            this.b = blue || 0;
        }
    }
    class HSB_Color extends SVG_Color {
        /**
         * Construct an HSB color,
         * With an SVG-compatible color string plus standard Hue, Saturation, Value color model components.
         * {{h: *, s: *, b: *, colorString: *}}
         * @param h - Hue, [0.0-1.0], colors of rainbow
         * @param s - Saturation, [0.0-1.0], 0=monochrome, 1=full color
         * @param b - Brightness, [0.0-1.0], 0=black, 1=white
         * @param str - SVG/Raphael color string
         */
        constructor( h, s, b, str ) {
            super( str );
            this.h = h || 0; // hue [0.0-1.0], colors of rainbow
            this.s = s || 0; // saturation [0.0-1.0], 0=monochrome, 1=full color
            this.b = b || 0; // brightness [0.0-1.0], 0=black, 1=white
        }
    }

Dyn.colorUtil = {
    // color modifiers for categorical gradients
    // probably best embedded in a gradient function.
    //kStartingHue: 0,					// shift hue so starting variable is blue
    //kCatHueSpread: 0.6,					// Spread of hue for values of categorical variable. 1.0=entire rainbow
    kCatSaturation: 0.7,					// [0-1] Categorical data: partial saturation fades colors so they look better
    kCatBrightness: 0.9,					// [0-1] Categorical data: partial brightness fades colors so they look better
    kMultiAttribStrokeValue: 1.0,			// [0-1] Multi-attribute data: full continuous color for dark colored line
    kMultiAttribFillValue: 0.4,			    // [0-1] Multi-attribute data: faded continuous color is good for fill, so dark line visible over circle icon
    kNumericSaturation: 0.95,				// [0-1] Numeric data: only use part of saturation range to avoid near-white values
    //kBrightnessDampenFactor: 0.9,		// dampen partially (1.0 = darker)
    kStandardMacGammaCorrection: (1 / 1.8),	// Finish partially-corrected MacOS gamma
    kStandardWinGammaCorrection: (1 / 2.5),	// assume uncorrected gamma
    kCatDeselectedSaturation: 0.5,			// categorical data: deselected cases have a lower saturation
    kNumDeselectedSaturation: 0.6,			// numeric data: deselected cases have a lower saturation (but no too much to obscure gradient)
    kMinNumAttributesForAlternatingHues: 6,	// if 6+ attributes in dataset, use alternating hues to make adjacent hues more distinct (if less, colors will be too close to eachother)

    kColorThemes: {
        "colorsLikeTinkerPlots": {
            id: 'std',                          // NOTE: IDs should never change so we are backward compatible for loading/saving theme settings
            isGrayScale: false,
            startingHue : 0,                    // shift hue so starting variable is blue
            brightnessDampenFactor: 0.9,		// dampen partially (1.0 = darker)
            catHueSpread: 0.8,					// Spread of hue for values of categorical variable. 1.0=entire rainbow
        },
        "colorBlindSafe":{
            id: 'safe',
            isGrayScale: false,
            startingHue : 0.5,                  // shift hue so starting variable is yellow
            brightnessDampenFactor: 1.0,		// don't dampen (1.0 = darker)
            catHueSpread: 0,					// unused
            // only for this color scheme
            //      each has from 3 to 11 colors,
            //      e.g. colorbrewer.BrBG.11[10]
            //      colorbrewer[colorBlindSafeSchemeNames[0-5]][3-11][0-10]
            colorBrewerSchemeNames: ['BrBG','PiYG','PRGn','PuOr','RdBu','RdYlBu' ], // was colorbrewer.colorBlindSafeSchemeNames
            colorBrewerSetMin: 3, // was colorbrewer.colorBlindSetMin
            colorBrewerSetMax: 11, // was colorbrewer.colorBlindSetMax
        },
        "grayScaleColors":{
            id: 'gray',
            isGrayScale: true,
            startingHue : 0,                    // unused
            brightnessDampenFactor: 1.0,		// don't dampen (1.0 = darker)
            catHueSpread: 0,					// unused
            // only for this color scheme
            singleCategoryBrightness: 0.8,
            colorBrewerSchemeNames: ['Greys'],
            colorBrewerSetMin: 3,
            colorBrewerSetMax: 9,
        },
        "grayScaleCustomColors":{   //NOTE: this is not used, colors are too dark, save for possible future use
            id: 'customGray',
            isGrayScale: true,
            startingHue : 0,                    // unused
            brightnessDampenFactor: 1.0,		// don't dampen (1.0 = darker)
            catHueSpread: 0.8,					// Spread of hue for values of categorical variable. 1.0=entire rainbow
            // only for this color scheme
            singleCategoryBrightness: 0.8,
        }
    },

    //colorSchema: "colorsLikeTinkerPlots",
    theme: null,

    // picked from https://colorbrewer2.org/?type=qualitative&scheme=Set3&n=12
    categoryColorOptions: [
        "#FF6900", "#FCB900", "#7BDCB5", "#00D084",
        "#8ED1FC", "#0693E3", '#fccde5','#ffed6f',
        '#bebada', '#bc80bd','#8dd3c7','#b15928'],

    numericalColorOptions: [ "#1b9e77","#d95f02","#7570b3","#e7298a",
        "#1f78b4","#e6ab02","#a6761d","#666666",
        '#ff7f00','#f781bf','#35978f', "#0693E3"],
};

Dyn.colorUtil.theme = Dyn.colorUtil.kColorThemes[ Dyn.preferences.getColorScheme() ];

/**
 * Set the color theme.
 * NOTE: to be called only by Dyn.preferences.setColorScheme() so that notification
 * order is correct to update all components that depend on color.
 * @param newSchemaString {string} -- param of Dyn.colorUtil.kColorThemes
 * @returns {boolean}
 */
Dyn.colorUtil.switchColorTheme = function( newSchemaString ) {
    //Dyn.colorUtil.colorSchema = newSchemaString;
    var success = (Dyn.colorUtil.kColorThemes[ newSchemaString ] !== null);
    Dyn.assert( success, "invalid color schema" );
    if( success ) {
        Dyn.colorUtil.theme = Dyn.colorUtil.kColorThemes[newSchemaString];
        mediator.publish( "colorUtil:newAttributeColors", { theme: Dyn.colorUtil.theme} ); // handle attribute colors first for dataSet
        success = true;
    }
    return success;
};

Dyn.colorUtil.HSB_Color = HSB_Color;
Dyn.colorUtil.RGB_Color = RGB_Color;
Dyn.colorUtil.SVG_Color = SVG_Color;

/** Dyn.colorUtil.dampenBrighnessByHue()

 Dampen the brightness of a color to make different hues more uniform
 in perceived color.  For example blues (hue = 0.6) at full brightness
 (1.0) are much darker than yellows, so we dampen the brightness of
 yellows to make color gradients across the hues more uniform
 (we can't make blue brighter). Similarly, all hues are dampened in
 proportion to the relative brightness of the darkest hue.

 Because color dampening produces muddy (dark) colors, the caller can
 pass in a dampening factor in range [0.0 - 1.0] to reduce the dampening effect.
 0 = no dampening, 1 = 100% of table values, 0.75 = 75% dampening.

 * @param iOldBrightness {number} [0.0 - 1.0]
 * @param iConstHue      {number} [0.0 - 1.0]
 * @param iDampenFactor  {number} [0.0 - 1.0]
 * @returns {number} new brightness factor [0.0 - 1.0]
 */
Dyn.colorUtil.dampenBrighnessByHue = function( iOldBrightness, iConstHue, iDampenFactor) {
	"use strict";
	// Photoshop "K" color values for Red, Yellow, Green, Aqua, Blue, Magenta
	// (hues 0,60,120,180,240,300,360; brightness & Saturation 100%)
	var	kBrightnessTable = [ 0.54, 0.05, 0.20, 0.15, 0.75, 0.46 ],
		kMaxK = 0.75,	// Blue is darkest
		kTableSize = kBrightnessTable.length; // matches kBrightnessTable array size

	// get the nearest values in brightness table
	var tHueIndex = iConstHue * kTableSize,
		tLower = Math.floor( tHueIndex ),
		tUpper = Math.ceil( tHueIndex ),
		tLowerFraction = (tLower < tUpper) ? tUpper - tHueIndex : 1.0,
		tUpperFraction = tHueIndex - tLower,
		tKValue,
		tDampenFraction;

	tLower = tLower % kTableSize; // probably not needed
	tUpper = tUpper % kTableSize; // upper can wrap around to zero (colors are in a circle).

	// interpolate between K values
	tKValue = kBrightnessTable[tLower] * tLowerFraction + kBrightnessTable[tUpper] * tUpperFraction;

	// convert to amount to dampen (zero for darkest hue)
	tDampenFraction = 1 - (( kMaxK - tKValue ) * iDampenFactor);

	return( iOldBrightness * tDampenFraction );
};

/** Dyn.colorUtil.calcAttributeColor()

	Calculate the color assigned to a variable in a dataset, based on
	it's index in the list of variables.  We take all the circle of hues
	and equally space the attributes to assign a hue to each.  This color
	is then used as a basis for the variable's color gradient.

 * @param attribIndex
 * @param attribCount
 * @returns {Dyn.colorUtil.HSB_Color}
 */
Dyn.colorUtil.calcAttributeColor = function( attribIndex, attribCount ) {
    "use strict";
    var tHue, tSaturation, tBrightness;

    switch( Dyn.colorUtil.theme.id ) {
    case "std":
    case "safe":
        if( attribCount >= Dyn.colorUtil.kMinNumAttributesForAlternatingHues &&
            Dyn.mathUtil.isOdd( attribIndex) ) {
            // rotate attributeIndex so every other attribute has a complementary hue (#1230)
            let adjustedCount = attribCount - (Dyn.mathUtil.isOdd( attribCount ) ? 1 : 0),
                indexShift = (adjustedCount/2) - (Dyn.mathUtil.isOdd( adjustedCount/2 ) ? 1 : 0);
            attribIndex = (attribIndex+indexShift) % adjustedCount; // rotate index to position of another odd attributeIndex
            Dyn.assert( Dyn.mathUtil.isOdd( attribIndex ) && Dyn.mathUtil.isEven(indexShift ) &&
                Dyn.mathUtil.isEven(adjustedCount ) && (attribIndex < attribCount && attribIndex > 0 ),
                "color shift calc error");
        }
        tHue = attribIndex / attribCount;	// get hue in range [0.0-1.0]
        tHue += Dyn.colorUtil.theme.startingHue;	// shift hue so starting attribute is blue
        // old color shift scheme pre-#1230
        // if( attribCount >= Dyn.colorUtil.kMinNumAttributesForAlternatingHues ) {
        //     tHue += (attribIndex % 2 ? 0 : 0.3);// shift so every other attribute has complementary hue
        // }
        tHue -= Math.floor( tHue );			// convert back to range [0 - 1]
        tSaturation = 1.0;
        tBrightness = Dyn.colorUtil.dampenBrighnessByHue( 1.0, tHue, Dyn.colorUtil.theme.brightnessDampenFactor );
        break;
    case "gray":
    case "customGray":
        tHue        = 0;
        tSaturation = 0;
        tBrightness = 1;
        break;
    }
    // console.log( "calcAttributeColor for attribute "+attribIndex+" of "+attribCount, "h:"+tHue, "s:"+tSaturation, "b:"+tBrightness,
    //     Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness ).colorString );
	return Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
};

/**
 * Calculate base color for attribute used as one of 2+ attributes on the axis
 */
Dyn.colorUtil.calcMultiAttributeColor = function( baseColor, attribIndex, attribCount, isFill ) {
    let color,
        normalizedValue = isFill ? Dyn.colorUtil.kMultiAttribFillValue : Dyn.colorUtil.kMultiAttribStrokeValue;

    switch( Dyn.colorUtil.theme.id ) {
    case "std":
    case "safe":
        color = Dyn.colorUtil.calcContinuousColorNormalized( baseColor.h, baseColor.s, baseColor.b, normalizedValue );
        break;
    case "gray":
    case "customGray": {
        let hue        = 0,
            saturation = 0,
            brightness = attribIndex / ((attribCount > 1) ? attribCount : 1);
        color = Dyn.colorUtil.calcContinuousColorNormalized( hue, saturation, brightness, normalizedValue );
        } break;
    }
    return color;
};

/**
 * Calculate a continuous color, like calcContinuousColor, but with a normalized value [0.0-1.0] instead of a case value.
 * @param hue {number} -- in [0.0-1.0] range
 * @param saturation {number} -- in [0.0-1.0] range
 * @param brightness {number} -- in [0.0-1.0] range
 * @param normalizedValue {number} -- in [0.0-1.0] range
 * @returns {Dyn.colorUtil.HSB_Color}
 */
Dyn.colorUtil.calcContinuousColorNormalized = function( hue, saturation, brightness, normalizedValue) {
	"use strict";
	Dyn.assert( Dyn.mathUtil.isFinite( normalizedValue ) && normalizedValue >= 0 && normalizedValue <= 1, "not a normalized numeric value");
	// adjust saturation and brightness along gradient
    if( Dyn.colorUtil.theme.isGrayScale ) {
        saturation = 0;
        brightness *= (1 - Dyn.colorUtil.kNumericSaturation) + (normalizedValue * Dyn.colorUtil.kNumericSaturation);
        brightness = Dyn.colorUtil.gammaCorrect( brightness );
    } else {
        saturation *= (1 - Dyn.colorUtil.kNumericSaturation) + (normalizedValue * Dyn.colorUtil.kNumericSaturation);
        brightness = Dyn.colorUtil.gammaCorrect( 1.0 - ((1.0 - brightness) * normalizedValue) );
    }
	return Dyn.colorUtil.hsb_to_PlatformColor( hue, saturation, brightness );
};

/**
 * Dyn.colorUtil.calcCaseColor()
 *
 * Calculate the color of the given case using the Attribute's color scheme and case value.
 *
 * @param {number} caseIndex
 * @param {Dyn.Attribute} selectedAttribute
 * @param {boolean} isCaseSelected
 * @param {{}} colorScheme -- case-invariant color options
 * @returns {Dyn.colorUtil.SVG_Color}
 */
Dyn.colorUtil.calcCaseColor = function( caseIndex, isCaseSelected, colorScheme ) {
	"use strict";
	var isDeselectedCase = colorScheme.useDeselection && ! isCaseSelected,
        colorAttribute = colorScheme.colorAttribute,
		newColor,
		calcFunction;

	if( colorAttribute ) {
        // calculate color dynamically from attribute color
        calcFunction = colorAttribute.statsPreFilter.isCategorical() ?
            Dyn.colorUtil.calcCategoryColor :
            Dyn.colorUtil.calcContinuousColor;
        newColor     = calcFunction(
            // Note: we always want pre-filter colors for cases, so case colors don't change with filters
            colorAttribute.statsPreFilter,
            colorAttribute.color,
            colorScheme.useNumericIntervals ? colorAttribute.caseIndexToNumericIntervalValue( caseIndex )
                                : colorAttribute.cases[caseIndex],
            isDeselectedCase,
            colorAttribute.colorMap,
            colorAttribute.isSortAscending );
	} else {
        // colors if no attribute is selected
		if( isCaseSelected ) {
			newColor = new Dyn.colorUtil.SVG_Color( Dyn.plotUtil.kCaseActiveColor );
		} else {
			newColor = new Dyn.colorUtil.SVG_Color( colorScheme.caseFillColor );
		}
	}
	return newColor;
};

/**  Dyn.colorUtil.calcContinuousColor()

	 Calculate the icon fill color for this numeric value of a continuous
	 variable.  Creates a gradient from white for the lowest numeric value,
	 to the attribute color for the highest numeric value. Returns the
	 missing value color for any non-numeric case values.

 * @param iAttributeStats
 * @param iAttributeColor
 * @param caseValue
 * @param isCaseDeselected
 * @param colorMap - IGNORE for numeric gradients
 * @param isSortAscending - IGNORE for numeric gradients
 * @returns {Dyn.colorUtil.HSB_Color}
 */
Dyn.colorUtil.calcContinuousColor = function( iAttributeStats, iAttributeColor, caseValue, isCaseDeselected /*, colorMap, isSortAscending */ ) {
	"use strict";
	var		tCaseColor = new Dyn.colorUtil.SVG_Color(Dyn.plotUtil.kCaseMissingValueColor);
	var		tRange = iAttributeStats.max - iAttributeStats.min;
	var		tHue		= iAttributeColor.h,	// break color into components
			tSaturation = iAttributeColor.s,
			tBrightness = iAttributeColor.b,
			tScale;

	// if we have a valid numeric range and case value along that range
	if ( Number.isFinite( tRange ) && Number.isFinite( caseValue )) {
		// check for min != max to fix the issue with case color when
		// all values are same for the attribute
		if ( tRange !== 0 ){
			// adjust saturation and brightness along gradient
			tScale = (caseValue - iAttributeStats.min) / tRange;
			if( Dyn.colorUtil.theme.isGrayScale ) {
			    tSaturation = 0;
			    tBrightness = 1.0 - tScale;
                if( isCaseDeselected ) {
                    tBrightness *= Dyn.colorUtil.kNumDeselectedSaturation;
                }
                tBrightness = Dyn.colorUtil.gammaCorrect( tBrightness );
            } else {
                tSaturation *= (1 - Dyn.colorUtil.kNumericSaturation) + (tScale * Dyn.colorUtil.kNumericSaturation);
                if( isCaseDeselected ) {
                    tSaturation *= Dyn.colorUtil.kNumDeselectedSaturation;
                }
                tBrightness = Dyn.colorUtil.gammaCorrect( 1.0 - ((1.0 - tBrightness) * tScale));
            }
			tCaseColor	= Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
		} else {
			tCaseColor = iAttributeColor;
		}
	}
	return tCaseColor;
};

/**
 *  Calculate the icon fill color for this category value of a categorical attribute.
 * @param iAttributeStats
 * @param iAttributeColor
 * @param caseValue
 * @param isCaseDeselected
 * @param colorMap - custom category colors, if any,
 * @param isSortAscending - if false, reverse color assignment of standard colors
 * @returns {*}
 */
Dyn.colorUtil.calcCategoryColor = function( iAttributeStats, iAttributeColor, caseValue, isCaseDeselected, colorMap, isSortAscending ) {
    "use strict";
    var tCaseColor;
    function getCustomCategooryColor() {
        if( colorMap ) {
            // check for custom category color
            tCaseColor = colorMap[caseValue];
            if( tCaseColor ) {
                tCaseColor = Dyn.colorUtil.calcCategoryColorCustomized( tCaseColor, isCaseDeselected );
            }
        }
        return Boolean( tCaseColor ); // has color object?
    }
    switch( Dyn.colorUtil.theme.id ) {
    case "std":
        if( ! getCustomCategooryColor()) {
            tCaseColor = Dyn.colorUtil.calcCategoryColorStandard( iAttributeStats, iAttributeColor, caseValue, isCaseDeselected, isSortAscending );
        }
        break;
    case "safe":
        if( ! getCustomCategooryColor()) {
            tCaseColor = Dyn.colorUtil.calcCategoryColorBySchema( iAttributeStats, caseValue, isCaseDeselected, isSortAscending );
        }
        break;
    case "gray":
        // TODO: allow custom colors but make sure they are gray (e.g. convert to gray).  For now we don't allow them.
        tCaseColor = Dyn.colorUtil.calcCategoryColorBySchema( iAttributeStats, caseValue, isCaseDeselected, isSortAscending );
        break;
    case "customGray":
        // TODO: allow custom colors but make sure they are gray (e.g. convert to gray).  For now we don't allow them.
        tCaseColor = Dyn.colorUtil.calcCategoryColorGrayScale( iAttributeStats, caseValue, isCaseDeselected, isSortAscending );
        break;
    }
    return tCaseColor;
};

/**
 * Calculate the icon fill color for this category value of a categorical
 * attribute.  Creates a gradient of hues, one per category value.
 * Returns the missing value color for any non-numeric case values.
 *
 * @param iAttributeStats
 * @param iAttributeColor
 * @param caseValue
 * @param isCaseDeselected
 * @param isSortAscending - if false, reverse color assignment of standard colors
 * @returns {Dyn.colorUtil.HSB_Color}
 */
Dyn.colorUtil.calcCategoryColorStandard = function( iAttributeStats, iAttributeColor, caseValue, isCaseDeselected, isSortAscending ) {
	"use strict";
	// get attribute's identifying color as basis for gradient
	var		tCategoryIndex = iAttributeStats.categories.indexOf( caseValue );
	var		tNumCategories = iAttributeStats.categories.length;
	var		tCaseColor;
	var		tHue		= iAttributeColor.h,
			tSaturation = iAttributeColor.s,
			tBrightness = iAttributeColor.b,
            adjustedIndex;

	// if we have a valid category
	if ( tCategoryIndex >= 0 ) {
        // reverse order or not (matches calcAttributeGradientColors())
        adjustedIndex = isSortAscending ? tCategoryIndex : (tNumCategories-(tCategoryIndex+1));
        // categories vary by hue
		if ( tNumCategories > 1 ) {
			tHue = adjustedIndex * (Dyn.colorUtil.theme.catHueSpread / tNumCategories);
			tHue += iAttributeColor.h;			// shift colors so first category is desired hue;
			tHue -= Math.floor(tHue);	        // get modulo to shift to [0-1] range
			// NOTE: this was an attempt to find good looking pattern for alternating hues for pie charts and lots of categories
            //if( tNumCategories >= Dyn.colorUtil.kMinNumAttributesForAlternatingHues ) {
            //   tHue += ((tCategoryIndex % 5  ) / 15);// shift so every other attribute has complementary hue
            //}
		}
		tSaturation = Dyn.colorUtil.kCatSaturation;
		if( isCaseDeselected ) {
			tSaturation *= Dyn.colorUtil.kCatDeselectedSaturation;
		}
		tBrightness = Dyn.colorUtil.kCatBrightness;
		tCaseColor = Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
        //console.log("calcCategoryColorStandard AttributeHue, HSB:", iAttributeColor.h, tHue, tSaturation, tBrightness );
	}
	else {
		tCaseColor = new Dyn.colorUtil.SVG_Color(Dyn.plotUtil.kCaseMissingValueColor);
	}

	return tCaseColor;
};

/**
 * Calculate the icon fill color for this category value of a categorical attribute
 * assuming that the specific category color is a custom color specified with the attribute/dataset.
 * See also calcCategoryColor().
 *
 * @param iCategoryColor
 * @param isCaseDeselected
 * @returns {{h, s, b, colorString}|Dyn.colorUtil.HSB_Color|*}
 */
Dyn.colorUtil.calcCategoryColorCustomized = function( iCategoryColor, isCaseDeselected ) {
    "use strict";
    // get attribute's identifying color as basis for gradient
    var tCaseColor,
        tHue           = iCategoryColor.h,
        tSaturation    = iCategoryColor.s,
        tBrightness    = iCategoryColor.b;

    if( isCaseDeselected ) {
        tSaturation *= Dyn.colorUtil.kCatDeselectedSaturation;
    }
    tCaseColor = Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );

    return tCaseColor;
};

Dyn.colorUtil.calcCategoryColorBySchema = function( iAttributeStats, caseValue, isCaseDeselected, isSortAscending ) {
    "use strict";
    var tCaseColor;

    if ( Dyn.dataUtil.isMissing( caseValue )) {
        tCaseColor = new Dyn.colorUtil.SVG_Color(Dyn.plotUtil.kCaseMissingValueColor);
    } else {
        // if we have a valid category
        let attributeIndex = iAttributeStats.attribIndex || 0,
            categoryIndex  = iAttributeStats.categories.indexOf( caseValue ),
            numCategories  = iAttributeStats.categories.length,
            adjustedIndex   = isSortAscending ? categoryIndex : (numCategories - (categoryIndex + 1)), // reverse order or not (matches calcAttributeGradientColors())
            colorString    = this.categoryIndex_to_colorBrewer_color( attributeIndex, adjustedIndex, numCategories );

        if( isCaseDeselected ) {
            let hsbColor = this.svgColorString_to_PlatformColor( colorString );
            hsbColor.s *= Dyn.colorUtil.kCatDeselectedSaturation;
            tCaseColor   = Dyn.colorUtil.hsb_to_PlatformColor( hsbColor.h, hsbColor.s, hsbColor.b );
        } else {
            tCaseColor = new Dyn.colorUtil.SVG_Color(colorString);
        }
    }
    return tCaseColor;
};

/**
 * convert category and attribute index to a color,
 * using the colorbrewer fixed color scheme.
 */
Dyn.colorUtil.categoryIndex_to_colorBrewer_color = function( attributeIndex, categoryIndex, numCategories ) {
    // get index of color from this.colorbrewer[colorBlindSafeSchemeNames[0-5]][3-11][0-10]
    // each attribute uses a different color scheme name, rotating through the theme's schemes (with wrap)
    // then use the set that matches the number of categories in the attribute (with wrap)
    let tNumColorSchemes = this.theme.colorBrewerSchemeNames.length,
        tSchemeName      = this.theme.colorBrewerSchemeNames[attributeIndex % tNumColorSchemes],
        tColorScheme     = this.colorbrewer[tSchemeName],
        tSetNumber       = Dyn.mathUtil.clipToIntegerRange( numCategories, this.theme.colorBrewerSetMin, this.theme.colorBrewerSetMax+1),
        tColorClass      = tColorScheme[ tSetNumber ],
        tColorString     = tColorClass[categoryIndex % tColorClass.length];
    return tColorString;
};

Dyn.colorUtil.calcCategoryColorGrayScale = function( iAttributeStats, caseValue, isCaseDeselected, isSortAscending ) {
    "use strict";
    var tCaseColor;

    if ( Dyn.dataUtil.isMissing( caseValue )) {
        tCaseColor = new Dyn.colorUtil.SVG_Color(Dyn.plotUtil.kCaseMissingValueColor);
    } else {
        // if we have a valid category
        let //attributeIndex = iAttributeStats.attribIndex || 0,
            categoryIndex  = iAttributeStats.categories.indexOf( caseValue ),
            numCategories  = iAttributeStats.categories.length || 1,
            adjustedIndex   = isSortAscending ? categoryIndex : (numCategories - (categoryIndex + 1)), // reverse order or not (matches calcAttributeGradientColors())
            hue = 0,
            saturation = 0,
            brightness = (numCategories > 1 ) ? (adjustedIndex * (Dyn.colorUtil.theme.catHueSpread / numCategories)) : Dyn.colorUtil.theme.singleCategoryBrightness;

        if( isCaseDeselected ) {
            brightness *= Dyn.colorUtil.kCatDeselectedSaturation;
        }
        tCaseColor = Dyn.colorUtil.hsb_to_PlatformColor( hue, saturation, brightness );
    }
    return tCaseColor;
};

/** Dyn.colorUtil.hsb_to_PlatformColor()
 *
 * convert a color in Hue, Saturation, Brightness (HSB) color space, range [0-1],
 * to a Rafael-compatible color value.
 * @param tHue
 * @param tSaturation
 * @param tBrightness
 * @returns {Dyn.colorUtil.HSB_Color}
 */
Dyn.colorUtil.hsb_to_PlatformColor = function( tHue, tSaturation, tBrightness ) {
	"use strict";
	return {
		h : tHue,
		s : tSaturation,
		b : tBrightness,
		colorString : Dyn.colorUtil.hsb_to_rgb( tHue, tSaturation, tBrightness )
	};
};

/** Dyn.colorUtil.rgb_to_PlatformColor()
 *
 * convert a color in Red, Green, Blue (RGB) color space, range [0-1],
 * to a Rafael/SVG-compatible/HTML color string (rgb values in range [0-255].
 *
 * note: exponential numbers ("0.5e-14") don't render correctly,
 * but SVG 'Interface RGBColor' says float is OK, so use .toFixed(4)
 *
 * @param red
 * @param green
 * @param blue
 * @returns {string} -- SVG color string
 */
Dyn.colorUtil.rgb_to_PlatformColor = function( red, green, blue ) {
	"use strict";
    function toHex(n) {
        // number in range [0-1] to hex string '00' to 'ff'
        // Dyn.assert( n<=1 && n>= 0);
        return('00'+Math.round(n*255).toString(16)).slice(-2);
    }
    //console.log('#' + toHex(red) + toHex(green) + toHex(blue));
    // make a hex string 1,1,1 => "#ffffff"
    return '#' + toHex(red) + toHex(green) + toHex(blue);
    // old way 1,1,1 => "rgb(255,255,255)" works for SVG but not HTML
	// return("rgb(" +
	// 			(red   * 255).toFixed(0) +","+
	// 			(green * 255).toFixed(0) +","+
	// 			(blue  * 255).toFixed(0) +")"
	// 		);
};

/**
 * Dyn.colorUtil.hsb_to_rgb()
 *
 * Converts from Hue, Saturation, and Value color representation
 * to Red, Green, Blue color representation.  From Foley & Van Dam, page 616.
 *
 * @param hue
 * @param saturation
 * @param brightness
 * @returns {string} -- SVG color string
 */
Dyn.colorUtil.hsb_to_rgb = function( hue, saturation, brightness ) {
	"use strict";
	var i,				// int
		f,p,q,t,		// float
		tPlatformColor;	// color string

	if (saturation===0) {
		tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor( brightness, brightness, brightness );
	}
	else {
		f = (hue >= 1.0) ? 0 : (hue * 6.0);
		i = Math.floor(f);
		f = f - i;		// fractional part of hue
		p = brightness * (1 - saturation);
		q = brightness * (1 - (saturation * f));
		t = brightness * (1 - (saturation * (1 - f)));

		switch (i) {
			case 0: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(brightness, t, p ); break;
			case 1: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(q, brightness, p ); break;
			case 2: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(p, brightness, t ); break;
			case 3: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(p, q, brightness ); break;
			case 4: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(t, p, brightness ); break;
			case 5: tPlatformColor = Dyn.colorUtil.rgb_to_PlatformColor(brightness, p, q ); break;
		}
	}
	return tPlatformColor;
};

/**
 * Dyn.colorUtil.gammaCorrect()
 *
 * 	Adjusts a brightness value from black (0.0) to white (1.0) with
 * 	a power function to compensate for non-linear brightness
 * 	of monitors.  Standard monitor gamma correction value is 1 / 2.5,
 * 	MacOS provides partial gamma correction of 1 / 1.4, requiring
 * 	an addition gamma of 1 / 1.8.
 *
 * @param value {Number} from 0-1
 * @returns {number}
 */
Dyn.colorUtil.gammaCorrect = function ( value ) {
	"use strict";
	return Math.pow( value, Dyn.colorUtil.kStandardMacGammaCorrection );
};

/**
 * Dyn.colorUtil.makeGradientSet()
 *
 * Create and return a Rafael set of rectangles which make an attribute gradient
 *
 * @param iPaper
 * @param iBounds { x, y, width, height } location to draw gradient
 * @param iAttribute {Dyn.Attribute} the attribute to color
 * @param wantHorizontal {Boolean} optional orientation
 * @param wantPreFilter {Boolean} optional, if true use the pre-filtered (full) range/categories.
 * @param dataRange {Dyn.mathUtil.Range} optional, range to use if wantPreFilter is false and attribute numerical.
 * @returns {*} - returns Paper.set() with filled rectangles covering iBounds
 */
Dyn.colorUtil.makeGradientSet = function( iPaper, iBounds, iAttribute, wantHorizontal, wantPreFilter, dataRange,
                                          extendedBounds ){
	"use strict";
	var gradientColors = Dyn.colorUtil.calcAttributeGradientColors(
			iAttribute,
			wantHorizontal ? iBounds.width : iBounds.height,
			wantPreFilter, dataRange, wantHorizontal ),
		numRects = gradientColors.length,
		gradientSet = iPaper.set(),
		x = iBounds.x,
		y = iBounds.y,
		width= iBounds.width / ( wantHorizontal ? numRects : 1 ),
		height=iBounds.height / ( wantHorizontal ? 1 : numRects );

    gradientColors.forEach( (color, i ) => {
        let h=height, w=width;
		if( wantHorizontal ) {
			x = iBounds.x + (width * i);
		} else {
			y = iBounds.y + (height * (numRects -(i+1)));
		}
        if( extendedBounds && i===(gradientColors.length-1)) {
            h += y - extendedBounds.top(); // extend the (n-1)th rectangle to cover the top end of the bounds
            y = extendedBounds.top();
        }
        if( extendedBounds && i===0) {
            h += extendedBounds.bottom() - y; // extend the 0th rectangle to cover the bottom end of the bounds
        }
        // Dyn.assert( [x,y,w,h].findIndex( i => ( i !== Math.round(i) )) === -1,
        //   "Rect coordinates must be integer for non-distorted colors. x:"+x+" y:"+y+" w:"+w+" h:"+h );
        // console.log( i, x, y, w, h, color );
		gradientSet.push( iPaper.
			rect( x, y, w, h ).
			attr( { fill: color, stroke: "none" })
		);
	});

	return gradientSet;
};

/** make an attribute's color gradient as an HTML string ('<svg ...</svg') */
Dyn.colorUtil.makeGradientHTML = function( iBounds, iAttribute, wantHorizontal, wantPreFilter , dataRange ){
    const border = 2; // one pixel border around gradient
    const borderColor = "white"//"#3d4146"; // same as table text color?
    let svgStr = '<div style="position: relative;">'+
            replaceParams( '<svg width="w1" height="h1" style="overflow: hidden; position: relative;">', {
                    w1: iBounds.width + 1, // +1 so border is fully visible
                    h1: iBounds.height + 1
                }),
        borderStr = replaceParams( '<rect x="x2" y="y2" width="w2" height="h2" fill="f2" />', {
                x2: iBounds.x,
                y2: iBounds.y,
                w2: iBounds.width,
                h2: iBounds.height,
                f2: borderColor
            }),
        svgEnd = '</svg></div>',
        rectStr = '';

    let innerRect = (new Dyn.mathUtil.Rect( iBounds )).expand( -border, -border ),
        gradientColors = Dyn.colorUtil.calcAttributeGradientColors(
            iAttribute,
            wantHorizontal ? innerRect.width : innerRect.height,
            wantPreFilter, dataRange, wantHorizontal ),
        numRects = gradientColors.length,
        x = innerRect.x,
        y = innerRect.y,
        width = innerRect.width / ( wantHorizontal ? numRects : 1 ),
        height = innerRect.height / ( wantHorizontal ? 1 : numRects );

    gradientColors.forEach( (color, i) => {
        if( wantHorizontal ) {
            x = innerRect.x + (width * i);
        } else {
            y = innerRect.y + (height * (numRects -(i+1)));
        }
        let r = replaceParams('<rect x="x1" y="y1" width="w1" height="h1" fill="f1" />', {
            x1: x,
            y1: y,
            w1: width,
            h1: height,
            f1: color,
        });
        rectStr += r;
    });
    return svgStr + borderStr + rectStr + svgEnd;

    function replaceParams( str, params ) {
        let str2 = str;
        for( let prop in params ) {
            if( params.hasOwnProperty( prop )) {
                str2 = str2.replace( prop, params[prop] );
            }
        }
        return str2;
    }
};


/**
 * Dyn.colorUtil.calcAttributeGradientColors()
 *
 * return an array of colors to form an attribute gradient, to the given resolution
 *
 * @param iAttribute
 * @param gradientWidth
 * @param wantPreFilter {Boolean} - optional, if true use the pre-filtered (full) range/categories.
 * @param [dataRange] {Dyn.mathUtil.Range}  - optional, range to use if wantPreFilter is false and attribute numerical.
 * @param [isHorizontal] {boolean} - optional, if true, we want a horizontal graident, false: vertical gradient
 * @returns []
 */
Dyn.colorUtil.calcAttributeGradientColors = function( iAttribute, gradientWidth, wantPreFilter, dataRange, isHorizontal ){
	"use strict";
	var gradientColors = [],
        reverseOrder = false,
		theStats = iAttribute ? ( wantPreFilter ? iAttribute.statsPreFilter : iAttribute.stats ) : null;
    if( iAttribute ) {
        reverseOrder = (! iAttribute.isSortAscending);
        theStats = ( wantPreFilter ? iAttribute.statsPreFilter : iAttribute.stats );
        if( theStats.isCategorical() && !isHorizontal ) {
            reverseOrder = ! reverseOrder; // categorical, vertical gradients go from top to bottom, reverse of usual order
        }
    }

	function calcNumericGradient( attributeColor, numRects, min, max ) {
	    const isGrayScale = Dyn.colorUtil.theme.isGrayScale;
		var	tCaseColor	= attributeColor.colorString,
			tHue		= attributeColor.h,	// break color into components
			tSaturation = attributeColor.s,
			tBrightness = attributeColor.b,
			tScale, i;

		for( i = 1; i<=numRects; ++i ) {
			// adjust saturation and brightness along gradient (same as calcContinuousColor())
			tScale = i/numRects; // scale ranges from [1/numRects to numRects/numRects]
			tScale = ((1-tScale) * min + tScale*max); // scale from [min to max], both in [0-1] range.
            tScale = Dyn.mathUtil.clipToMinMax( 0, 1, tScale ); // if outside range, color = min or max color
            if( reverseOrder ) {
                tScale = 1.0 - tScale;
            }
			tScale = (1-Dyn.colorUtil.kNumericSaturation) + (tScale * Dyn.colorUtil.kNumericSaturation);
            if( isGrayScale ) {
                tSaturation = 0;
                tBrightness = Dyn.colorUtil.gammaCorrect( 1.0 - tScale);
            } else {
                tSaturation = attributeColor.s * tScale;
                tBrightness = Dyn.colorUtil.gammaCorrect( 1.0 - ((1.0 - attributeColor.b) * tScale) );
            }
			tCaseColor	= Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
			gradientColors.push( tCaseColor.colorString );
		}
	}

	function calcCategoricalGradient( attributeIndex, attributeColor, categories, colorMap ) {
		var	tHue		= attributeColor.h,	// break color into components
			tSaturation = attributeColor.s,
			tBrightness = attributeColor.b,
			tNumCategories = categories.length,
               id = Dyn.colorUtil.theme.id,
            i, adjustedIndex;

		for( i = 0; i<tNumCategories; ++i ) {
            // reverse order or not (matches calcCategoryColorStandard())
            adjustedIndex = reverseOrder ? (tNumCategories - (i + 1)) : i;
            //console.log( "calcCategoricalGradient i="+i+" j="+adjustedIndex+" for "+(iAttribute?iAttribute.name:""));
            let color     = null;
            switch( id ) {
            case "std":
                if( colorMap ) {
                    color = colorMap[categories[adjustedIndex]]; // find custom color for category if any
                }
                if( !color ) {
                    // calc standard color, vary by hue to match calcCategoryColorStandard()
                    if( tNumCategories > 1 ) {
                        tHue = adjustedIndex * (Dyn.colorUtil.theme.catHueSpread / tNumCategories);
                        tHue += attributeColor.h;	// shift colors so first category is desired hue;
                        tHue -= Math.floor( tHue );	// get modulo to shift to [0-1] range
                    }
                    tSaturation = Dyn.colorUtil.kCatSaturation;
                    tBrightness = Dyn.colorUtil.kCatBrightness;
                    color       = Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
                    //console.log("calcCategoricalGradient AttributeHue, HSB:", attributeColor.h, tHue, tSaturation, tBrightness );
                }
                break;
            case "safe":
                if( colorMap ) {
                    color = colorMap[categories[adjustedIndex]]; // find custom color for category if any
                }
                if( !color ) {
                    color = new Dyn.colorUtil.SVG_Color(Dyn.colorUtil.categoryIndex_to_colorBrewer_color( attributeIndex, i, tNumCategories ));
                }
                break;
            case "gray":
                color = new Dyn.colorUtil.SVG_Color(Dyn.colorUtil.categoryIndex_to_colorBrewer_color( attributeIndex, i, tNumCategories ));
                break;
            case "customGray":
                tSaturation = 0;
                if( tNumCategories > 1 ) {
                    tBrightness = adjustedIndex * (Dyn.colorUtil.theme.catHueSpread / tNumCategories);
                } else {
                    tBrightness = Dyn.colorUtil.grayScaleColors.singleCategoryBrightness;
                }
                tHue  = 0;
                color = Dyn.colorUtil.hsb_to_PlatformColor( tHue, tSaturation, tBrightness );
                break;
            }
			gradientColors.push( color.colorString );
		}
	}

	if ( theStats ){
		if( theStats.isCategorical()) {
			calcCategoricalGradient( iAttribute.attribIndex, iAttribute.color, theStats.categories /* one rectangle per category */, iAttribute.colorMap );
		} else {
		    let fullRange = new Dyn.mathUtil.Range( iAttribute.statsPreFilter.min, iAttribute.statsPreFilter.max ),
                currentRange = ( dataRange && ! wantPreFilter ) ? dataRange : fullRange, // see issue #947
                unitScale = Dyn.mathUtil.invertSafely( fullRange.width()),
                min = (currentRange.min - fullRange.min) * unitScale, // relative start of gradient, normally 0, range [0-1]
                max = 1 - ((fullRange.max - currentRange.max) * unitScale); // relative end of gradent, normally 1, range [0-1]
			calcNumericGradient( iAttribute.color, gradientWidth /* one rectangle per pixel */, min, max );
		}
	} else {
		// no attribute gradient (default)
		gradientColors.push( Dyn.plotUtil.kCaseColor );
		// calcCategoricalGradient( {colorString: Dyn.plotUtil.kCaseColor}, ["default"] /* one rectangle */ );
	}

	return gradientColors;
};

/**
 * Convert an SVC/Rafael color string to a HSB_Color object.
 * *
 * NOTE: for now we use 'parseColor' to implement this:
 * parseColor
 * Copyright 2011 THEtheChad Elliott
 * Released under the MIT and GPL licenses.
 * Parse hex/rgb{a} color syntax.
 * from https://gist.github.com/1297590
 *
 * We have the option of using 'RGBColor':
 *   A class to parse color values
 *   author Stoyan Stefanov <sstoo@gmail.com>
 *   link   http://www.phpied.com/rgb-color-parser-in-javascript/
 *   license Use it if you like it
 *   Example use:
 * var color = new RGBColor('darkblue');
 if (color.ok) { // 'ok' is true when the parsing was a success
            // alert channels
            alert(color.r + ', ' + color.g + ', ' + color.b);
            // alert HEX and RGB
            alert(color.toHex());
            alert(color.toRGB());
        }
 * also based on DG.ColorUtilities.rgbColorString_to_PlatformColor() which is also based on parseColor()
 *
 * @param iColor -- the original SVG color name or rgb color string
 * @param [iWantRGB_Color] --  if true, create Dyn.colorUtil.RGB_Color() compatible object instead of HSB.
 * @returns {Dyn.colorUtil.HSB_Color} -- colorString with HSB (or RGB) components
 */
Dyn.colorUtil.svgColorString_to_PlatformColor = function( iColor, iWantRGB_Color ) {
    "use strict";

    // Allow assignments as comparisons

    // convert color name to hex color
    var cache,
        color = Dyn.colorUtil.svgColorNameToHexColor( iColor );

    // Checks for 6 digit hex and converts string to integer
    if (cache = /^#([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})/.exec(color))
        cache = [parseInt(cache[1], 16), parseInt(cache[2], 16), parseInt(cache[3], 16)];

    // Checks for 3 digit hex and converts string to integer
    else if (cache = /^#([\da-fA-F])([\da-fA-F])([\da-fA-F])/.exec(color))
        cache = [parseInt(cache[1], 16) * 17, parseInt(cache[2], 16) * 17, parseInt(cache[3], 16) * 17];

    // Checks for rgba and converts string to
    // integer/float using unary + operator to save bytes
    else if (cache = /^rgba\(([\d]+),([\d]+),([\d]+),([\d]+|[\d]*.[\d]+)\)/.exec(color))
        cache = [+cache[1], +cache[2], +cache[3], +cache[4]];

    // Checks for rgb and converts string to
    // integer/float using unary + operator to save bytes
    else if (cache = /^rgb\(([\d]+),([\d]+),([\d]+)\)/.exec(color))
        cache = [+cache[1], +cache[2], +cache[3]];

    // Otherwise throw an exception to make debugging easier
    else throw new Error(color + ' is not supported by parseColor');

    // Performs RGBA conversion by default
    //if( isNaN(cache[3])) { cache[3] = 1; }
    // Adds or removes 4th value based on rgba support
    // Support is flipped twice to prevent erros if
    // it's not defined
    /* return cache.slice(0,3 + !!$.support.rgba); */

    // return new object with color components and original color string,
    // like hsb_to_PlatformColor()
    var r = cache[0]/255,
        g = cache[1]/255,
        b = cache[2]/255,
        newColor;

    if( iWantRGB_Color ) {
        newColor = new Dyn.colorUtil.RGB_Color( r, g, b, iColor );
    } else {
        var newHSB = Raphael.rgb2hsb( r, g, b );
        newColor = new Dyn.colorUtil.HSB_Color( newHSB.h, newHSB.s, newHSB.b, iColor );
    }
    return newColor;
};

/**
 * Convert an SVC/Rafael color name to the equivalent hex color.
 *
 * Based on RGBColor() by Stoyan Stefanov <sstoo@gmail.com>
 * http://www.phpied.com/rgb-color-parser-in-javascript/
 * and DG.ColorUtilities.colorNameToHexColor()
 *
 * @param color_string
 * @return {String} String of form #rrggbb, hex colors if match found.
 */
Dyn.colorUtil.svgColorNameToHexColor = function( color_string ) {
    "use strict";

    // strip any leading #, remove spaces, make lower case
    if (color_string.charAt(0) === '#') { // remove # if any
        color_string = color_string.substr(1,6);
    }
    color_string = color_string.replace(/ /g,'');
    color_string = color_string.toLowerCase();

    // try simple matches
    if( Dyn.colorUtil.svgColorNames.hasOwnProperty(color_string)) {
        color_string = Dyn.colorUtil.svgColorNames[color_string];
    }
    color_string = '#'+color_string; // add back in the #

    return color_string;
};

/**
 *  Is the value a color name according to the SVG color table?
 *  Ignore non-strings, ignore case, and ignore spaces in strings
 *  e.g. 'cadetblue' OR 'Cadet Blue' returns true,
 *       svgColorNameToHexColor('Cadet Blue') === '#5f9ea0'
 */
Dyn.colorUtil.isColorName = function( value ) {
    if((typeof value === "string") && (value.length > 0)) {
        value = value.replace(/ /g,'');
        value = value.toLowerCase();
        return Dyn.colorUtil.svgColorNames.hasOwnProperty(value);
    }
    return false;
};

    /** get the color brightness in the 0-255 range, from hex color strings like '#000', '#ffaa11'. */
    Dyn.colorUtil.getColorBrightness = function( hexColor ) {
        // function hexToRgb(hex) from https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
        let result = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i.exec( hexColor );
        if( result ) {
            let factor = (result[1].length===1) ? 17 : 1, // times 16 for single digit colors like "#f0f"
                r = parseInt(result[1], 16)*factor,
                g = parseInt(result[2], 16)*factor,
                b = parseInt(result[3], 16)*factor;
                // from https://www.w3.org/TR/AERT/#color-contrast
            return ((r*299) + (g*587) + (b*114)) / 1000; // range 0-255
        }
        return 128;
    }

    /**
     * add a color brightness value [0-255] to the SVG_Color/HSB_color/RGB_Color object
     * @param color {Dyn.colorUtil.SVG_Color}
     */
    Dyn.colorUtil.calcColorBrightness = function( color ) {
        color.b255 = this.getColorBrightness( color.colorString );
    }

/**
 * SVG color names (compatible with rafael/css/w3c/svg),
 * from http://www.phpied.com/rgb-color-parser-in-javascript/
 * see also http://www.w3.org/TR/css3-color/#svg-color
 * based on DG.ColorUtilities.simpleColorNames
 * @type {Object}
 */
Dyn.colorUtil.svgColorNames = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dodgerblue: '1e90ff',
    feldspar: 'd19275',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred : 'cd5c5c',
    indigo : '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgrey: 'd3d3d3',
    lightgreen: '90ee90',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslateblue: '8470ff',
    lightslategray: '778899',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '00ff00',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'ff00ff',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370d8',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'd87093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    red: 'ff0000',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    violetred: 'd02090',
    wheat: 'f5deb3',
    white: 'ffffff',
    whitesmoke: 'f5f5f5',
    yellow: 'ffff00',
    yellowgreen: '9acd32'
};


// colorbrewer colors from https://github.com/axismaps/colorbrewer/blob/master/export/colorbrewer.js
Dyn.colorUtil.colorbrewer = {
    // This product includes color specifications and designs developed by Cynthia Brewer (http://colorbrewer.org/).
    // JavaScript specs as packaged in the D3 library (d3js.org). Please see license at http://colorbrewer.org/export/LICENSE.txt
    YlGn: {
        3: ["#f7fcb9","#addd8e","#31a354"],
        4: ["#ffffcc","#c2e699","#78c679","#238443"],
        5: ["#ffffcc","#c2e699","#78c679","#31a354","#006837"],
        6: ["#ffffcc","#d9f0a3","#addd8e","#78c679","#31a354","#006837"],
        7: ["#ffffcc","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#005a32"],
        8: ["#ffffe5","#f7fcb9","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#005a32"],
        9: ["#ffffe5","#f7fcb9","#d9f0a3","#addd8e","#78c679","#41ab5d","#238443","#006837","#004529"]
    },YlGnBu: {
        3: ["#edf8b1","#7fcdbb","#2c7fb8"],
        4: ["#ffffcc","#a1dab4","#41b6c4","#225ea8"],
        5: ["#ffffcc","#a1dab4","#41b6c4","#2c7fb8","#253494"],
        6: ["#ffffcc","#c7e9b4","#7fcdbb","#41b6c4","#2c7fb8","#253494"],
        7: ["#ffffcc","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"],
        8: ["#ffffd9","#edf8b1","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#0c2c84"],
        9: ["#ffffd9","#edf8b1","#c7e9b4","#7fcdbb","#41b6c4","#1d91c0","#225ea8","#253494","#081d58"]
    },GnBu: {
        3: ["#e0f3db","#a8ddb5","#43a2ca"],
        4: ["#f0f9e8","#bae4bc","#7bccc4","#2b8cbe"],
        5: ["#f0f9e8","#bae4bc","#7bccc4","#43a2ca","#0868ac"],
        6: ["#f0f9e8","#ccebc5","#a8ddb5","#7bccc4","#43a2ca","#0868ac"],
        7: ["#f0f9e8","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#08589e"],
        8: ["#f7fcf0","#e0f3db","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#08589e"],
        9: ["#f7fcf0","#e0f3db","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#0868ac","#084081"]
    },BuGn: {
        3: ["#e5f5f9","#99d8c9","#2ca25f"],
        4: ["#edf8fb","#b2e2e2","#66c2a4","#238b45"],
        5: ["#edf8fb","#b2e2e2","#66c2a4","#2ca25f","#006d2c"],
        6: ["#edf8fb","#ccece6","#99d8c9","#66c2a4","#2ca25f","#006d2c"],
        7: ["#edf8fb","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#005824"],
        8: ["#f7fcfd","#e5f5f9","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#005824"],
        9: ["#f7fcfd","#e5f5f9","#ccece6","#99d8c9","#66c2a4","#41ae76","#238b45","#006d2c","#00441b"]
    },PuBuGn: {
        3: ["#ece2f0","#a6bddb","#1c9099"],
        4: ["#f6eff7","#bdc9e1","#67a9cf","#02818a"],
        5: ["#f6eff7","#bdc9e1","#67a9cf","#1c9099","#016c59"],
        6: ["#f6eff7","#d0d1e6","#a6bddb","#67a9cf","#1c9099","#016c59"],
        7: ["#f6eff7","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016450"],
        8: ["#fff7fb","#ece2f0","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016450"],
        9: ["#fff7fb","#ece2f0","#d0d1e6","#a6bddb","#67a9cf","#3690c0","#02818a","#016c59","#014636"]
    },PuBu: {
        3: ["#ece7f2","#a6bddb","#2b8cbe"],
        4: ["#f1eef6","#bdc9e1","#74a9cf","#0570b0"],
        5: ["#f1eef6","#bdc9e1","#74a9cf","#2b8cbe","#045a8d"],
        6: ["#f1eef6","#d0d1e6","#a6bddb","#74a9cf","#2b8cbe","#045a8d"],
        7: ["#f1eef6","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#034e7b"],
        8: ["#fff7fb","#ece7f2","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#034e7b"],
        9: ["#fff7fb","#ece7f2","#d0d1e6","#a6bddb","#74a9cf","#3690c0","#0570b0","#045a8d","#023858"]
    },BuPu: {
        3: ["#e0ecf4","#9ebcda","#8856a7"],
        4: ["#edf8fb","#b3cde3","#8c96c6","#88419d"],
        5: ["#edf8fb","#b3cde3","#8c96c6","#8856a7","#810f7c"],
        6: ["#edf8fb","#bfd3e6","#9ebcda","#8c96c6","#8856a7","#810f7c"],
        7: ["#edf8fb","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#6e016b"],
        8: ["#f7fcfd","#e0ecf4","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#6e016b"],
        9: ["#f7fcfd","#e0ecf4","#bfd3e6","#9ebcda","#8c96c6","#8c6bb1","#88419d","#810f7c","#4d004b"]
    },RdPu: {
        3: ["#fde0dd","#fa9fb5","#c51b8a"],
        4: ["#feebe2","#fbb4b9","#f768a1","#ae017e"],
        5: ["#feebe2","#fbb4b9","#f768a1","#c51b8a","#7a0177"],
        6: ["#feebe2","#fcc5c0","#fa9fb5","#f768a1","#c51b8a","#7a0177"],
        7: ["#feebe2","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177"],
        8: ["#fff7f3","#fde0dd","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177"],
        9: ["#fff7f3","#fde0dd","#fcc5c0","#fa9fb5","#f768a1","#dd3497","#ae017e","#7a0177","#49006a"]
    },PuRd: {
        3: ["#e7e1ef","#c994c7","#dd1c77"],
        4: ["#f1eef6","#d7b5d8","#df65b0","#ce1256"],
        5: ["#f1eef6","#d7b5d8","#df65b0","#dd1c77","#980043"],
        6: ["#f1eef6","#d4b9da","#c994c7","#df65b0","#dd1c77","#980043"],
        7: ["#f1eef6","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#91003f"],
        8: ["#f7f4f9","#e7e1ef","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#91003f"],
        9: ["#f7f4f9","#e7e1ef","#d4b9da","#c994c7","#df65b0","#e7298a","#ce1256","#980043","#67001f"]
    },OrRd: {
        3: ["#fee8c8","#fdbb84","#e34a33"],
        4: ["#fef0d9","#fdcc8a","#fc8d59","#d7301f"],
        5: ["#fef0d9","#fdcc8a","#fc8d59","#e34a33","#b30000"],
        6: ["#fef0d9","#fdd49e","#fdbb84","#fc8d59","#e34a33","#b30000"],
        7: ["#fef0d9","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#990000"],
        8: ["#fff7ec","#fee8c8","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#990000"],
        9: ["#fff7ec","#fee8c8","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#b30000","#7f0000"]
    },YlOrRd: {
        3: ["#ffeda0","#feb24c","#f03b20"],
        4: ["#ffffb2","#fecc5c","#fd8d3c","#e31a1c"],
        5: ["#ffffb2","#fecc5c","#fd8d3c","#f03b20","#bd0026"],
        6: ["#ffffb2","#fed976","#feb24c","#fd8d3c","#f03b20","#bd0026"],
        7: ["#ffffb2","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#b10026"],
        8: ["#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#b10026"],
        9: ["#ffffcc","#ffeda0","#fed976","#feb24c","#fd8d3c","#fc4e2a","#e31a1c","#bd0026","#800026"]
    },YlOrBr: {
        3: ["#fff7bc","#fec44f","#d95f0e"],
        4: ["#ffffd4","#fed98e","#fe9929","#cc4c02"],
        5: ["#ffffd4","#fed98e","#fe9929","#d95f0e","#993404"],
        6: ["#ffffd4","#fee391","#fec44f","#fe9929","#d95f0e","#993404"],
        7: ["#ffffd4","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#8c2d04"],
        8: ["#ffffe5","#fff7bc","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#8c2d04"],
        9: ["#ffffe5","#fff7bc","#fee391","#fec44f","#fe9929","#ec7014","#cc4c02","#993404","#662506"]
    },Purples: {
        3: ["#efedf5","#bcbddc","#756bb1"],
        4: ["#f2f0f7","#cbc9e2","#9e9ac8","#6a51a3"],
        5: ["#f2f0f7","#cbc9e2","#9e9ac8","#756bb1","#54278f"],
        6: ["#f2f0f7","#dadaeb","#bcbddc","#9e9ac8","#756bb1","#54278f"],
        7: ["#f2f0f7","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#4a1486"],
        8: ["#fcfbfd","#efedf5","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#4a1486"],
        9: ["#fcfbfd","#efedf5","#dadaeb","#bcbddc","#9e9ac8","#807dba","#6a51a3","#54278f","#3f007d"]
    },Blues: {
        3: ["#deebf7","#9ecae1","#3182bd"],
        4: ["#eff3ff","#bdd7e7","#6baed6","#2171b5"],
        5: ["#eff3ff","#bdd7e7","#6baed6","#3182bd","#08519c"],
        6: ["#eff3ff","#c6dbef","#9ecae1","#6baed6","#3182bd","#08519c"],
        7: ["#eff3ff","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#084594"],
        8: ["#f7fbff","#deebf7","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#084594"],
        9: ["#f7fbff","#deebf7","#c6dbef","#9ecae1","#6baed6","#4292c6","#2171b5","#08519c","#08306b"]
    },Greens: {
        3: ["#e5f5e0","#a1d99b","#31a354"],
        4: ["#edf8e9","#bae4b3","#74c476","#238b45"],
        5: ["#edf8e9","#bae4b3","#74c476","#31a354","#006d2c"],
        6: ["#edf8e9","#c7e9c0","#a1d99b","#74c476","#31a354","#006d2c"],
        7: ["#edf8e9","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#005a32"],
        8: ["#f7fcf5","#e5f5e0","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#005a32"],
        9: ["#f7fcf5","#e5f5e0","#c7e9c0","#a1d99b","#74c476","#41ab5d","#238b45","#006d2c","#00441b"]
    },Oranges: {
        3: ["#fee6ce","#fdae6b","#e6550d"],
        4: ["#feedde","#fdbe85","#fd8d3c","#d94701"],
        5: ["#feedde","#fdbe85","#fd8d3c","#e6550d","#a63603"],
        6: ["#feedde","#fdd0a2","#fdae6b","#fd8d3c","#e6550d","#a63603"],
        7: ["#feedde","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#8c2d04"],
        8: ["#fff5eb","#fee6ce","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#8c2d04"],
        9: ["#fff5eb","#fee6ce","#fdd0a2","#fdae6b","#fd8d3c","#f16913","#d94801","#a63603","#7f2704"]
    },Reds: {
        3: ["#fee0d2","#fc9272","#de2d26"],
        4: ["#fee5d9","#fcae91","#fb6a4a","#cb181d"],
        5: ["#fee5d9","#fcae91","#fb6a4a","#de2d26","#a50f15"],
        6: ["#fee5d9","#fcbba1","#fc9272","#fb6a4a","#de2d26","#a50f15"],
        7: ["#fee5d9","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#99000d"],
        8: ["#fff5f0","#fee0d2","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#99000d"],
        9: ["#fff5f0","#fee0d2","#fcbba1","#fc9272","#fb6a4a","#ef3b2c","#cb181d","#a50f15","#67000d"]
    },Greys: {
        3: ["#f0f0f0","#bdbdbd","#636363"],
        4: ["#f7f7f7","#cccccc","#969696","#525252"],
        5: ["#f7f7f7","#cccccc","#969696","#636363","#252525"],
        6: ["#f7f7f7","#d9d9d9","#bdbdbd","#969696","#636363","#252525"],
        7: ["#f7f7f7","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525"],
        8: ["#ffffff","#f0f0f0","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525"],
        9: ["#ffffff","#f0f0f0","#d9d9d9","#bdbdbd","#969696","#737373","#525252","#252525","#000000"]
    },PuOr: {
        3: ["#f1a340","#f7f7f7","#998ec3"],
        4: ["#e66101","#fdb863","#b2abd2","#5e3c99"],
        5: ["#e66101","#fdb863","#f7f7f7","#b2abd2","#5e3c99"],
        6: ["#b35806","#f1a340","#fee0b6","#d8daeb","#998ec3","#542788"],
        7: ["#b35806","#f1a340","#fee0b6","#f7f7f7","#d8daeb","#998ec3","#542788"],
        8: ["#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788"],
        9: ["#b35806","#e08214","#fdb863","#fee0b6","#f7f7f7","#d8daeb","#b2abd2","#8073ac","#542788"],
        10: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"],
        11: ["#7f3b08","#b35806","#e08214","#fdb863","#fee0b6","#f7f7f7","#d8daeb","#b2abd2","#8073ac","#542788","#2d004b"]
    },BrBG: {
        3: ["#d8b365","#f5f5f5","#5ab4ac"],
        4: ["#a6611a","#dfc27d","#80cdc1","#018571"],
        5: ["#a6611a","#dfc27d","#f5f5f5","#80cdc1","#018571"],
        6: ["#8c510a","#d8b365","#f6e8c3","#c7eae5","#5ab4ac","#01665e"],
        7: ["#8c510a","#d8b365","#f6e8c3","#f5f5f5","#c7eae5","#5ab4ac","#01665e"],
        8: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e"],
        9: ["#8c510a","#bf812d","#dfc27d","#f6e8c3","#f5f5f5","#c7eae5","#80cdc1","#35978f","#01665e"],
        10: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"],
        11: ["#543005","#8c510a","#bf812d","#dfc27d","#f6e8c3","#f5f5f5","#c7eae5","#80cdc1","#35978f","#01665e","#003c30"]
    },PRGn: {
        3: ["#af8dc3","#f7f7f7","#7fbf7b"],
        4: ["#7b3294","#c2a5cf","#a6dba0","#008837"],
        5: ["#7b3294","#c2a5cf","#f7f7f7","#a6dba0","#008837"],
        6: ["#762a83","#af8dc3","#e7d4e8","#d9f0d3","#7fbf7b","#1b7837"],
        7: ["#762a83","#af8dc3","#e7d4e8","#f7f7f7","#d9f0d3","#7fbf7b","#1b7837"],
        8: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
        9: ["#762a83","#9970ab","#c2a5cf","#e7d4e8","#f7f7f7","#d9f0d3","#a6dba0","#5aae61","#1b7837"],
        10: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"],
        11: ["#40004b","#762a83","#9970ab","#c2a5cf","#e7d4e8","#f7f7f7","#d9f0d3","#a6dba0","#5aae61","#1b7837","#00441b"]
    },PiYG: {
        3: ["#e9a3c9","#f7f7f7","#a1d76a"],
        4: ["#d01c8b","#f1b6da","#b8e186","#4dac26"],
        5: ["#d01c8b","#f1b6da","#f7f7f7","#b8e186","#4dac26"],
        6: ["#c51b7d","#e9a3c9","#fde0ef","#e6f5d0","#a1d76a","#4d9221"],
        7: ["#c51b7d","#e9a3c9","#fde0ef","#f7f7f7","#e6f5d0","#a1d76a","#4d9221"],
        8: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
        9: ["#c51b7d","#de77ae","#f1b6da","#fde0ef","#f7f7f7","#e6f5d0","#b8e186","#7fbc41","#4d9221"],
        10: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"],
        11: ["#8e0152","#c51b7d","#de77ae","#f1b6da","#fde0ef","#f7f7f7","#e6f5d0","#b8e186","#7fbc41","#4d9221","#276419"]
    },RdBu: { // ?? possibly not color safe
        3: ["#ef8a62","#f7f7f7","#67a9cf"],
        4: ["#ca0020","#f4a582","#92c5de","#0571b0"],
        5: ["#ca0020","#f4a582","#f7f7f7","#92c5de","#0571b0"],
        6: ["#b2182b","#ef8a62","#fddbc7","#d1e5f0","#67a9cf","#2166ac"],
        7: ["#b2182b","#ef8a62","#fddbc7","#f7f7f7","#d1e5f0","#67a9cf","#2166ac"],
        8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
        9: ["#b2182b","#d6604d","#f4a582","#fddbc7","#f7f7f7","#d1e5f0","#92c5de","#4393c3","#2166ac"],
        10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"],
        11: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#f7f7f7","#d1e5f0","#92c5de","#4393c3","#2166ac","#053061"]
    },RdGy: {
        3: ["#ef8a62","#ffffff","#999999"],
        4: ["#ca0020","#f4a582","#bababa","#404040"],
        5: ["#ca0020","#f4a582","#ffffff","#bababa","#404040"],
        6: ["#b2182b","#ef8a62","#fddbc7","#e0e0e0","#999999","#4d4d4d"],
        7: ["#b2182b","#ef8a62","#fddbc7","#ffffff","#e0e0e0","#999999","#4d4d4d"],
        8: ["#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d"],
        9: ["#b2182b","#d6604d","#f4a582","#fddbc7","#ffffff","#e0e0e0","#bababa","#878787","#4d4d4d"],
        10: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"],
        11: ["#67001f","#b2182b","#d6604d","#f4a582","#fddbc7","#ffffff","#e0e0e0","#bababa","#878787","#4d4d4d","#1a1a1a"]
    },RdYlBu: {
        3: ["#fc8d59","#ffffbf","#91bfdb"],
        4: ["#d7191c","#fdae61","#abd9e9","#2c7bb6"],
        5: ["#d7191c","#fdae61","#ffffbf","#abd9e9","#2c7bb6"],
        6: ["#d73027","#fc8d59","#fee090","#e0f3f8","#91bfdb","#4575b4"],
        7: ["#d73027","#fc8d59","#fee090","#ffffbf","#e0f3f8","#91bfdb","#4575b4"],
        8: ["#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4"],
        9: ["#d73027","#f46d43","#fdae61","#fee090","#ffffbf","#e0f3f8","#abd9e9","#74add1","#4575b4"],
        10: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"],
        11: ["#a50026","#d73027","#f46d43","#fdae61","#fee090","#ffffbf","#e0f3f8","#abd9e9","#74add1","#4575b4","#313695"]
    },Spectral: { // NOT color safe
        3: ["#fc8d59","#ffffbf","#99d594"],
        4: ["#d7191c","#fdae61","#abdda4","#2b83ba"],
        5: ["#d7191c","#fdae61","#ffffbf","#abdda4","#2b83ba"],
        6: ["#d53e4f","#fc8d59","#fee08b","#e6f598","#99d594","#3288bd"],
        7: ["#d53e4f","#fc8d59","#fee08b","#ffffbf","#e6f598","#99d594","#3288bd"],
        8: ["#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd"],
        9: ["#d53e4f","#f46d43","#fdae61","#fee08b","#ffffbf","#e6f598","#abdda4","#66c2a5","#3288bd"],
        10: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"],
        11: ["#9e0142","#d53e4f","#f46d43","#fdae61","#fee08b","#ffffbf","#e6f598","#abdda4","#66c2a5","#3288bd","#5e4fa2"]
    },RdYlGn: { // NOT color safe
        3: ["#fc8d59","#ffffbf","#91cf60"],
        4: ["#d7191c","#fdae61","#a6d96a","#1a9641"],
        5: ["#d7191c","#fdae61","#ffffbf","#a6d96a","#1a9641"],
        6: ["#d73027","#fc8d59","#fee08b","#d9ef8b","#91cf60","#1a9850"],
        7: ["#d73027","#fc8d59","#fee08b","#ffffbf","#d9ef8b","#91cf60","#1a9850"],
        8: ["#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
        9: ["#d73027","#f46d43","#fdae61","#fee08b","#ffffbf","#d9ef8b","#a6d96a","#66bd63","#1a9850"],
        10: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"],
        11: ["#a50026","#d73027","#f46d43","#fdae61","#fee08b","#ffffbf","#d9ef8b","#a6d96a","#66bd63","#1a9850","#006837"]
    },Accent: {
        3: ["#7fc97f","#beaed4","#fdc086"],
        4: ["#7fc97f","#beaed4","#fdc086","#ffff99"],
        5: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0"],
        6: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f"],
        7: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17"],
        8: ["#7fc97f","#beaed4","#fdc086","#ffff99","#386cb0","#f0027f","#bf5b17","#666666"]
    },Dark2: {
        3: ["#1b9e77","#d95f02","#7570b3"],
        4: ["#1b9e77","#d95f02","#7570b3","#e7298a"],
        5: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e"],
        6: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02"],
        7: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d"],
        8: ["#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"]
    },Paired: {
        3: ["#a6cee3","#1f78b4","#b2df8a"],
        4: ["#a6cee3","#1f78b4","#b2df8a","#33a02c"],
        5: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99"],
        6: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c"],
        7: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f"],
        8: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00"],
        9: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6"],
        10: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a"],
        11: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99"],
        12: ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928"]
    },Pastel1: {
        3: ["#fbb4ae","#b3cde3","#ccebc5"],
        4: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4"],
        5: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6"],
        6: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc"],
        7: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd"],
        8: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec"],
        9: ["#fbb4ae","#b3cde3","#ccebc5","#decbe4","#fed9a6","#ffffcc","#e5d8bd","#fddaec","#f2f2f2"]
    },Pastel2: {
        3: ["#b3e2cd","#fdcdac","#cbd5e8"],
        4: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4"],
        5: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9"],
        6: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae"],
        7: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc"],
        8: ["#b3e2cd","#fdcdac","#cbd5e8","#f4cae4","#e6f5c9","#fff2ae","#f1e2cc","#cccccc"]
    },Set1: {
        3: ["#e41a1c","#377eb8","#4daf4a"],
        4: ["#e41a1c","#377eb8","#4daf4a","#984ea3"],
        5: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00"],
        6: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33"],
        7: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628"],
        8: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf"],
        9: ["#e41a1c","#377eb8","#4daf4a","#984ea3","#ff7f00","#ffff33","#a65628","#f781bf","#999999"]
    },Set2: {
        3: ["#66c2a5","#fc8d62","#8da0cb"],
        4: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3"],
        5: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854"],
        6: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f"],
        7: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494"],
        8: ["#66c2a5","#fc8d62","#8da0cb","#e78ac3","#a6d854","#ffd92f","#e5c494","#b3b3b3"]
    },Set3: {
        3: ["#8dd3c7","#ffffb3","#bebada"],
        4: ["#8dd3c7","#ffffb3","#bebada","#fb8072"],
        5: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3"],
        6: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462"],
        7: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69"],
        8: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5"],
        9: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9"],
        10: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd"],
        11: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5"],
        12: ["#8dd3c7","#ffffb3","#bebada","#fb8072","#80b1d3","#fdb462","#b3de69","#fccde5","#d9d9d9","#bc80bd","#ccebc5","#ffed6f"]
    }};


//Dyn.colorUtil.colorbrewer.allColorModels = [
//'YlGn',
//'YlGnBu',
//'GnBu',
//'BuGn',
//'PuBuGn',
//'PuBu',
//'BuPu',
//'RdPu',
//'PuRd',
//'OrRd',
//'YlOrRd',
//'YlOrBr',
//'Purples'
//////..
//];

// copied from https://github.com/axismaps/colorbrewer/blob/master/colorbrewer.js
//Dyn.colorUtil.colorbrewer.schemeNames = {sequential: ["BuGn","BuPu","GnBu","OrRd","PuBu","PuBuGn","PuRd","RdPu","YlGn","YlGnBu","YlOrBr","YlOrRd"],
//    singlehue:["Blues","Greens","Greys","Oranges","Purples","Reds"],
//    diverging: ["BrBG","PiYG","PRGn","PuOr","RdBu","RdGy","RdYlBu","RdYlGn","Spectral"],
//    qualitative: ["Accent","Dark2","Paired","Pastel1","Pastel2","Set1","Set2","Set3"] };


    Dyn.colorUtil.unitTest = function() {
        let unitTester = new Dyn.UnitTester( "Dyn.colorUtil.unitTest()" );
        function assertEqual( a, b ) {
            unitTester.test( a === b, "Dyn.colorUtil.unitTest() failure, " + a + " !== " + b );
        }

        assertEqual( Dyn.colorUtil.rgb_to_PlatformColor(1,1,1), '#ffffff' );
        assertEqual( Dyn.colorUtil.rgb_to_PlatformColor(0,0.5,1), '#0080ff' );
        assertEqual( Dyn.colorUtil.rgb_to_PlatformColor(1,0.5,0), '#ff8000' );
        assertEqual( Dyn.colorUtil.getColorBrightness( "#ffffff" ), 255 );
        assertEqual( Dyn.colorUtil.getColorBrightness( "#000000" ), 0 );
        assertEqual( Dyn.colorUtil.getColorBrightness( "#0088ff" ), 108.902 );
        assertEqual( Dyn.colorUtil.getColorBrightness( "#08f" ), 108.902 );
        unitTester.report();
        return true;
    };
    Dyn.debugColorUtil_UnitTestHasRun = ( Dyn.debugging ? Dyn.colorUtil.unitTest() : false );

} // wrapDyncolorUtil
